import { Link } from "react-router-dom";

import { connect } from "react-redux";

var CurrentUser = require('lib/account/CurrentUser');
var Features = require('lib/account/Features');

var AltModal = require("components/utility/AltModal");
var Glyphicon = require("components/utility/icons/Glyphicon");
var TextTypes = require('lib/academic/TextTypes');

var SmartBookSearch = require("components/reading/books/SmartBookSearch");
var LogReadingModal = require("components/reading/books/LogReadingModal");

var BookCover = require("components/reading/books/BookCover");
var BookDisplay = require("components/reading/books/BookDisplay")

var Spinner = require("components/utility/Spinner");
var ReactTooltip = require("react-tooltip");
var BookTextVariety = require("components/reading/books/BookTextVariety");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var WhooosReadingServices = require('lib/web/WhooosReadingServices');
var StudentMetrics = require("lib/data/StudentMetrics");

require("reading/books/book_action_section.scss");

@connect(
	(state, props) => {
		var userID = CurrentUser.get().id;
		// Must match call in SmartBookSearch EXACTLY
		var books = ReadingSelectors.books({ state, 
			conditions: { userID, allowDraft: true, nonBlank: ["text_id", "title"] }});
		return { existingBooks: books };
	},
	(dispatch, props) => ({})
)
class BookActionSection extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			// Note there is also a selectedBook (for log reading only) in StudentHomePage :(
			selectedBook: null,

			loading: false, quiz: null, bookStatus: null, 
			showBookModal: false, bookKeyIndex: 0
		}
	}

	isFirstBook() {
		return (_.size(this.props.existingBooks) == 0);
	}

	onBookSelect(book, isFirst) {
		this.setState({ selectedBook: book }, () => {
			if (!book) { return; }
			this.setState({
				getTextVariety: false
			});
			LuckyOrangeClient.tagComponent("BookActionSection");

			if (this.props.studentDashboard) {
				var activityType = this.props.openActivityType;
				if (activityType == "quizzes-passed") {
					this.openQuiz();
				} else if (activityType == "reviews") {
					this.openReview();
				} else if (activityType == "questions") {
					this.openQuestions();
				} else if (activityType == "minutes" || activityType == "pages" ) {
					this.openLogReading();
				} else if (activityType == "exercises") {
					this.openExcercise();
				} else if (activityType == "question-builder") {
					this.openQuestionBuilder();
				}
			} else {
				this.refs.modal.show();	
			}

			var quizSearchParams = { draft: true, text_id: this.state.selectedBook.text_id,
				user_id: CurrentUser.get().id, start_date: 'any' };

			CurrentUser.api().getQuizzes(quizSearchParams, $wr.apiHandler((response) => {
				var quiz = response.quizzes[0];
				this.setState({ quiz: quiz });
			}));
		});
	}

	openQuiz(e) {
		$wr.nope(e)
		if (this.checkTextVariety("quiz")) {
			this.setState({ loading: true });
			this.props.openBookActivity("quiz", this.state.selectedBook, this.isFirstBook());
		}
	}

	openLogReading(e) {
		$wr.nope(e)
		this.submitOverride("open_log-reading", this.state.selectedBook.text_id, true);
		this.setState({ showBookModal: true });
		this.refs.modal.hide();
	}

	closeLogReading(readingWasLogged) {
		if (readingWasLogged) {
			this.setState({ showBookModal: false, bookKeyIndex: (this.state.bookKeyIndex + 1) });
		} else {
			this.setState({ showBookModal: false });
		}
	}

	openReview(e) {
		$wr.nope(e)
		if (this.checkTextVariety("review")) {
			this.submitOverride("open_review", this.state.selectedBook.text_id, true);
			this.setState({ loading: true });
			this.props.openBookActivity("review", this.state.selectedBook, this.isFirstBook());
		}
	}

	openExcercise(e) {
		$wr.nope(e)
		if (this.checkTextVariety("exercise")) {
			this.submitOverride("open_exercice", this.state.selectedBook.text_id, true);
			this.setState({ loading: true });
			this.props.openBookActivity("exercise", this.state.selectedBook, this.isFirstBook());
		}
	}

	openQuestions(e) {
		$wr.nope(e)
		if (this.checkTextVariety("question")) {
			this.submitOverride("open_question", this.state.selectedBook.text_id, true);
			this.setState({ loading: true });
			this.props.openBookActivity("question", this.state.selectedBook, this.isFirstBook());
		}
	}

	openQuestionBuilder(e) {
		$wr.nope(e)
		// Don't check text variety for quizzes
		this.setState({ loading: true });
		this.props.openBookActivity("question_builder", this.state.selectedBook, this.isFirstBook());
	}

	textVarietySelected(book) {
		this.setState({ loading: true });
		this.props.openBookActivity(this.state.requestedAction, book, this.isFirstBook());
	}

	checkTextVariety(action) {
		if (this.props.studentDashboard) {
			return true;
		}
		if (this.state.selectedBook) {
			if (this.state.selectedBook.overridden) {
				this.setState({
					getTextVariety: true,
					requestedAction: action
				});
				return false
			}
			return true
		}
		return false
	}

	resetTextVariety() {
		this.setState({
			getTextVariety: false 
		});
	}

	submitOverride(attribute_name,text_id,value) {
		var user = CurrentUser.get()
		var override_data = {
			instance_id: text_id,
			instance_type: "book",
			attribute_name: attribute_name,
			value: value,
			user_id: user.id,
			user_role: user.role,
		}

		var url = WhooosReadingServices.Matilda.url("/overrides");
		$wr.postJSON(url,{override:override_data}, function(data) {
			var newBook = $.extend({}, this.props.book)
			newBook.text_variety = value
		}.bind(this));
	}

	setBookStatus(value) {
		this.setState({ bookStatus: value });
	}

	renderChoiceModal() {
		if (this.state.loading) {
			var loadingIcon = (
				<div><Spinner placeholder={ true } scale={ 1.7 } /></div>
			);

		} else if (this.state.getTextVariety) {
			var modalContent = (
				<BookTextVariety reset={this.resetTextVariety} book={ this.state.selectedBook }
				onSubmit={ this.textVarietySelected } />
			);

		} else {

			if (this.state.bookStatus == null) {
				var modalContent = (
					<div className="primaryOnly">
						<p className="finishedQuestion">
							Have you finished this book?
						</p>
						<div className="primaryOptions">
							<a href="#" className="actionOp" onClick={ this.setBookStatus.bind(this, STILL_READING) }>
								<img src={ require("reading/open-book.png") } alt="Still Reading" />
								<span>I'm still reading</span>
							</a>
							<a href="#" className="actionOp" onClick={ this.setBookStatus.bind(this, FINISHED) }>
								<img src={ require("reading/closed-book.png") } alt="Finished" />
								<span>I finished</span>
							</a>
						</div>
					</div>
				);

			} else if (this.state.bookStatus == STILL_READING) {
				if (Features.isEnabled(Features.LOG_READING)) {
					var logReadingOption = (
						<a href="#" className="actionOp logReadingOp" onClick={ this.openLogReading }>
							<img src={ require("reading/log-reading.png") } alt="Log Reading" />
							<span>Log Reading</span>
						</a>
					); 
				}
				if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
					var exerciseOption = (
						<a href="#" className="actionOp" onClick={ this.openExcercise }>
							<img src={ require("reading/exercise-small.png") } alt="Do an Exercise" />
							<span>Start an Exercise</span>
						</a>
					);
				}

				if ((logReadingOption == undefined) && (exerciseOption == undefined)) {
					var modalContent = (
						<div className="primaryOnly">
							<a href="#" className="backLink" onClick={ this.setBookStatus.bind(this, null) }>
								<Glyphicon icon="arrow-left"/> Back
							</a>
							<div className="primaryOptions stillReading">
								<a href="#" className="actionOp questionOp" onClick={ this.openQuestions }>
									<img src={ require("reading/question.png") } alt="Answer a Question" />
									<span>Answer a Question</span>
								</a>
							</div>
						</div>
					);

				} else {
					var modalContent = (
						<div>
							<a href="#" className="backLink" onClick={ this.setBookStatus.bind(this, null) }>
								<Glyphicon icon="arrow-left"/> Back
							</a>
							<div className="primaryOptions stillReading">
								<a href="#" className="actionOp questionOp soloOp" onClick={ this.openQuestions }>
									<img src={ require("reading/question.png") } alt="Answer a Question" />
									<span>Answer a Question</span>
								</a>
								<span className="verticalDivider"></span>
							</div>
							<div className="secondaryOptions">
								{ logReadingOption }
								{ exerciseOption }
							</div>
						</div>
					);

				}


			} else if (this.state.bookStatus == FINISHED) {
				if (Features.isEnabled(Features.LOG_READING)) {
					var logReadingOption = (
						<a href="#" className="actionOp logReadingOp" onClick={ this.openLogReading }>
							<img src={ require("reading/log-reading.png") } alt="Log Reading" />
							<span>Log Reading</span>
						</a>
					); 
				}
				if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
					var exerciseOption = (
						<a href="#" className="actionOp" onClick={ this.openExcercise }>
							<img src={ require("reading/exercise-small.png") } alt="Do an Exercise" />
							<span>Start an Exercise</span>
						</a>
					);
				}

				if (this.state.quiz) {
					if (this.state.quiz.draft) {
						var quizStatus = " quizDraft";
						var quizOption = (
							<a href="#" className="actionOp quizOp soloOp quizDraft" onClick={ this.openQuiz }>
								<img src={ require("reading/take-a-quiz.png") } alt="Complete Your Quiz" />
								<span>Complete Quiz</span>
							</a>
						)
					} else {
						var quizStatus = " quizCompleted";
						var quizOption = (
							<a href="#" className="actionOp quizOp soloOp quizCompleted">
								<img src={ require("reading/take-a-quiz.png") } alt="Quiz Completed" />
								<span className="quizCompletedText">You completed the quiz!</span>
							</a>
						)
					}
				} else {
					var quizOption = (
						<a href="#" className="actionOp quizOp soloOp" onClick={ this.openQuiz }
							data-tip="Finish the book before you take a quiz!">
							<img src={ require("reading/take-a-quiz.png") } alt="Take a Quiz" />
							<span>Take a Quiz</span>
						</a>
					)
				}

				var modalContent = (
					<div>
						<a href="#" className="backLink" onClick={ this.setBookStatus.bind(this, null) }>
							<Glyphicon icon="arrow-left"/> Back
						</a>

						<div className={ "primaryOptions " + quizStatus }>
							{ quizOption }
							<span className="verticalDivider"></span>
						</div>
						<div className="secondaryOptions">
							{ logReadingOption }
							<a href="#" className="actionOp" onClick={ this.openReview }>
								<img src={ require("reading/review-small.png") } alt="Write a Review" />
								<span>Write a Review</span>
							</a>
							{ exerciseOption }
						</div>
					</div>
				);
			}
		}

		return (
			<AltModal className="bookActionModal" ref="modal"
				headerText="What do you want to do next?" onShow={ this.setBookStatus.bind(this, null) }>
				<div className="selectedBookHeader">
					<BookCover book={ this.state.selectedBook } coverWidth={ 70 }
						showTitle={ true } showAuthor={ true } />
				</div>
				{ loadingIcon }
				<div className="bookOptions">
					{ modalContent }
				</div>
			</AltModal>
		);
	}

	clearSelectedBook() {
		this.setState({ selectedBook: null })
	}

	componentDidMount() {
		$(window.document).on("clear-selected-book", this.clearSelectedBook)
	}

	componentWillUnmount() {
		$(window.document).off("clear-selected-book", this.clearSelectedBook)
	}

	onBack(bookStatus) {
		this.refs.modal.show();
		this.setState({ showBookModal: false }, () => {
			this.setBookStatus(bookStatus)
		})
	}

	render() {
		if (this.state.selectedBook != null) {
			var actionModal = this.renderChoiceModal();

			var bookModal = (
				<LogReadingModal initialBook={ this.state.selectedBook }
					open={ this.state.showBookModal } onClose={ this.closeLogReading }
					key={ this.state.selectedBook.text_id } onBack={ this.onBack }
					bookStatus={ this.state.bookStatus } />
			);
		}

		if (!this.props.studentDashboard && this.props.popularBooks.length == 0) {
			var suggestedBooks = (
				<div><Spinner placeholder={ true } scale={ 1.7 } /></div>
			);
		} else {
			if (!_.isEmpty(this.props.recommendedBooks)) {
				var recommendedBooks = _.map(this.props.recommendedBooks, function(book) {
					return (
						<BookDisplay showCover hideTitleIfCover
							textID={ book.text_id } key={ book.text_id }
							onClick={ this.onBookSelect.bind(this, book) } />
					);
				}.bind(this));

				// var recommendedBooks = _.map(this.props.recommendedBooks, function(book) {
				// 	return (
				// 		<div className="bookDisplayContainer" key={ book.text_id }>
				// 			<a className="coverLink" key={ book.text_id } onClick={ this.onBookSelect.bind(this, book) }>
				// 				<BookCover book={ book } />
				// 			</a>
				// 		</div>
				// 	);
				// }.bind(this));
				var recommendedBooksContainer = (
					<div className="recommendedBooksContainer">
						<p>Teacher's Picks</p>
						{ recommendedBooks }
					</div>
				)
			}

			// Popular Books...

			if (this.props.recommendedBooks && !this.props.studentDashboard) {
				if (this.props.recommendedBooks.length <= 5) {
					var popularBooks = _.map(this.props.popularBooks, function(book) {
						return (
							<a className="coverLink" key={ book.text_id } onClick={ this.onBookSelect.bind(this, book) }>
								<BookCover book={ book } key={ book.text_id } />
							</a>
						);
					}.bind(this));

					var popularBooksSliced = _.first(popularBooks, (6 - this.props.recommendedBooks.length));

					var popularBooksContainer = (
						<div className="popularBooksContainer">
							<p>Popular Books</p>
							{ popularBooksSliced }
						</div>	
					)	
				}
			}

			if (!this.props.studentDashboard) {
				var findBookHeader = (<p className="findBookHeader">What are you going to read next?</p>)
			}

			var suggestedBooks = (
				<div className="suggestedBooksArea">
					{ findBookHeader }
					{ recommendedBooksContainer }
					{ popularBooksContainer }
				</div>
			);

		}

		// Recommended Books...
		var openActivityType = this.props.openActivityType;
		if (this.props.studentDashboard && openActivityType) {
			var className = "bookActionSection studentDashboard";
			var actionImage = (<img src={ StudentMetrics.getIcon(this.props.openActivityType) } className="actionImage" />
			)
			if (openActivityType == StudentMetrics.TYPES.QUESTIONS) {
				var actionText = (
					<p className="actionText">Answer a question!</p>
				)
			} else if (openActivityType == StudentMetrics.TYPES.QUIZZES_PASSED) {
				var actionText = (
					<p className="actionText">Take a quiz!</p>
				)
			} else if (openActivityType == StudentMetrics.TYPES.REVIEWS) {
				var actionText = (
					<p className="actionText">Write a review!</p>
				)
			} else if (openActivityType == StudentMetrics.TYPES.EXERCISES) {
				var actionText = (
					<p className="actionText">Do an exercise!</p>
				)
			} else if (openActivityType == StudentMetrics.TYPES.MINUTES) {
				var actionText = (
					<p className="actionText">Log your reading!</p>
				)
			} else if (openActivityType == StudentMetrics.TYPES.PAGES) {
				var actionText = (
					<p className="actionText">Log your reading!</p>
				)
			} 
		} else {
			var className = "bookActionSection"
		}

		var header = (<span>{actionImage}{actionText}<p className="findBookHeader">Find what you read:</p></span>)
		if ( this.props.sectionDividerHeader ) {
			header = (
				<div className="dividerSection">
					<div className="dividerArea"></div>
					<div className="nameArea">
						<span className="nameString">
							Find a New Book
						</span>
					</div>
				</div>
			)
		}

		return (
			<div className={ className }>
				{ header }
				<div className="bookSearchBox">
					<SmartBookSearch onBookSelect={ this.onBookSelect } userID={ CurrentUser.get().id }
						selectedBook={ this.state.selectedBook } key={ this.state.bookKeyIndex } />
				</div>
				{ suggestedBooks }
				{ actionModal }
				{ bookModal }
			</div>
		)
	}

}

BookActionSection.WrappedComponent.propTypes = StrictPropTypes({
	openBookActivity: PropTypes.func.isRequired,
	popularBooks: PropTypes.array,
	recommendedBooks: PropTypes.array.isRequired,
	existingBooks: PropTypes.array,
	studentDashboard: PropTypes.bool,
	openActivityType: PropTypes.string

});

var FINISHED = "finished";
var STILL_READING = "reading";


module.exports = BookActionSection;


// WEBPACK FOOTER //
// ./modules/components/reading/books/BookActionSection.js